import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FileNameSetService {

  fileName$: Subject<string>  = new Subject<string>()
  setFileName$: Subject<string> = new Subject<string>()

  constructor() {
    this.fileName$.subscribe({
      next: (res) => {
        this.fileNameSet(res)
      }
    })
  }

  fileNameSet(name: string) {
    this.setFileName$.next(name.replace('attachment; filename=', ''))
  }
}
